import { Box } from '@mui/material';
import { Suspense } from 'react';

import { AuthService } from 'shared/config/oidcClient/authServices';
import useAuth from 'shared/hooks/useAuth';
import { useInitialEffect } from 'shared/hooks/useInitialEffect';
import { usePublicPageDetector } from 'shared/hooks/usePublicPageDetector';
import { Header } from 'shared/ui/Header';
import { Navbar } from 'shared/ui/Navbar';
import { Toast } from 'shared/ui/Toast/Toast';

import { AppRouter } from './providers/router';

const App = () => {
  const { login, authenticated, setIsInited, isInited, setIsLoading } =
    useAuth();
  const isPublicPage = usePublicPageDetector();

  useInitialEffect(async () => {
    setIsLoading(true);
    try {
      const authService = new AuthService();

      await authService.getUser().then(async (user) => {
        if (user) {
          await login(user);
        }
      });
      setIsInited(true);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log('initialize app error', error);
    }
  });

  const nav = isInited && authenticated;

  return (
    <Box minHeight="100vh" display="flex">
      <Box flexGrow={1}>
        <Suspense fallback="">
          {!isPublicPage && authenticated && <Header />}
          <Box bgcolor="default" display="flex">
            {!isPublicPage && nav && <Navbar />}
            <Box flex="1 1">{isInited && <AppRouter />}</Box>
          </Box>
        </Suspense>
      </Box>
      <Toast />
    </Box>
  );
};

export default App;
